import React from "react";
import { useLang } from "../../i18n/LangContext";
import '../../assets/scss/quiz-editorial.scss';

interface ProgressBarProps {
  progress: number; // 0-100
  label?: string; // e.g. "Питання 7 / 15" — shown instead of the percent when set
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, label }) => {
  const { lang } = useLang();

  return (
    <div className="progress-bar">
      <div className="progress-bar__track">
        <div
          className="progress-bar__fill"
          style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
        ></div>
      </div>
      <div className="progress-bar__text">
        {label || `${Math.round(progress)}% ${lang === "uk" ? "пройдено" : "Complete"}`}
      </div>
    </div>
  );
};

export default ProgressBar;
